import React from 'react';
import { decimalToAmerican, formatPropSelection } from '../../constants/sports';

function MyBetsView({ bets, loading, onRefresh }) {
  const activeBets = bets.filter(b => b.status === 'active');
  const settledBets = bets.filter(b => b.status !== 'active');

  const statusBadge = (status) => {
    const map = {
      active: { label: 'Active', cls: 'status-active' },
      won: { label: 'Won', cls: 'status-won' },
      lost: { label: 'Lost', cls: 'status-lost' },
      push: { label: 'Push', cls: 'status-push' },
      cancelled: { label: 'Cancelled', cls: 'status-cancelled' },
    };
    const s = map[status] || { label: status, cls: '' };
    return <span className={`bet-status-badge ${s.cls}`}>{s.label}</span>;
  };

  const legStatusIcon = (status) => {
    if (status === 'won') return '✅';
    if (status === 'lost') return '❌';
    if (status === 'push') return '➖';
    if (status === 'cancelled') return '🚫';
    return '⏳';
  };

  const formatSelection = (leg) => {
    if (leg.market === 'player_prop') return formatPropSelection(leg);
    if (leg.market === 'h2h') {
      if (leg.selection === 'home') return leg.homeTeam;
      if (leg.selection === 'away') return leg.awayTeam;
      return 'Draw';
    }
    if (leg.market === 'spreads') {
      const team = leg.selection === 'home' ? leg.homeTeam : leg.awayTeam;
      return `${team} ${leg.point > 0 ? '+' : ''}${leg.point}`;
    }
    if (leg.market === 'totals') {
      return `${leg.selection === 'over' ? 'Over' : 'Under'} ${leg.point}`;
    }
    return leg.selection;
  };

  const formatMarket = (market) => {
    if (market === 'h2h') return 'ML';
    if (market === 'spreads') return 'Spread';
    if (market === 'totals') return 'Total';
    if (market === 'player_prop') return 'Prop';
    return market;
  };

  const renderBet = (bet) => (
    <div key={bet.id} className={`my-bet-card ${bet.status}`}>
      <div className="my-bet-header">
        <div className="my-bet-type">
          {bet.type === 'parlay' ? `Parlay (${bet.legs.length} legs)` : 'Straight'}
          {statusBadge(bet.status)}
        </div>
        <div className="my-bet-time">
          {new Date(bet.placedAt).toLocaleDateString([], { month: 'short', day: 'numeric' })}{' '}
          {new Date(bet.placedAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}
        </div>
      </div>

      <div className="my-bet-legs">
        {bet.legs.map((leg, i) => (
          <div key={i} className="my-bet-leg">
            <span className="my-bet-leg-status">{legStatusIcon(leg.status)}</span>
            <div className="my-bet-leg-info">
              <span className="my-bet-leg-selection">{formatSelection(leg)}</span>
              <span className="my-bet-leg-details">
                {formatMarket(leg.market)} &middot; {leg.awayTeam} @ {leg.homeTeam}
              </span>
            </div>
            <span className="my-bet-leg-odds">{decimalToAmerican(leg.odds)}</span>
          </div>
        ))}
      </div>

      <div className="my-bet-footer">
        <div className="my-bet-wager">
          <span>Wager</span>
          <span>{bet.currency === 'impostor' ? '🔴' : '🔵'} {bet.wagerTokens.toFixed(2)}</span>
        </div>
        {bet.status === 'active' ? (
          <div className="my-bet-potential">
            <span>To win</span>
            <span>{bet.currency === 'impostor' ? '🔴' : '🔵'} {bet.potentialPayout.toFixed(2)}</span>
          </div>
        ) : bet.actualPayout != null ? (
          <div className={`my-bet-result ${bet.actualPayout > bet.wagerTokens ? 'positive' : bet.actualPayout === bet.wagerTokens ? '' : 'negative'}`}>
            <span>Payout</span>
            <span>{bet.currency === 'impostor' ? '🔴' : '🔵'} {bet.actualPayout.toFixed(2)}</span>
          </div>
        ) : null}
      </div>
    </div>
  );

  if (loading) {
    return <div className="sports-loading">Loading bets...</div>;
  }

  return (
    <div className="my-bets-view">
      <div className="my-bets-header">
        <button className="my-bets-refresh" onClick={onRefresh}>Refresh</button>
      </div>

      {activeBets.length > 0 && (
        <div className="my-bets-section">
          <h3 className="my-bets-section-title">Active ({activeBets.length})</h3>
          {activeBets.map(renderBet)}
        </div>
      )}

      {settledBets.length > 0 && (
        <div className="my-bets-section">
          <h3 className="my-bets-section-title">Settled</h3>
          {settledBets.map(renderBet)}
        </div>
      )}

      {bets.length === 0 && (
        <div className="sports-empty">No bets yet. Pick some games and place your first bet!</div>
      )}
    </div>
  );
}

export default MyBetsView;
